import Styles from "../../pages/Styles/NomineeStyles.module.scss";
import {
  Stack,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  RadioGroupProps,
  TextFieldProps,
  OutlinedTextFieldProps,
  ButtonProps,
  FormHelperText,
} from "@mui/material";
import { ISelectProofProps } from "../../shared/dtos";
import proofEmpty from "../../Components/assets/Images/proofemptycircle.svg";
import proofDone from "../../Components/assets/Images/prooftickedcircle.svg";
import TickCircle from "../../Components/assets/Images/tick-circle.svg";
import EmptyCircle from "../../Components/assets/Images/TickEmptyCircle.svg";

interface IRadioProps extends RadioGroupProps {}

interface ITextProps extends OutlinedTextFieldProps {}

export default function SelectProof(
  props: IRadioProps & ITextProps & ISelectProofProps,
) {
  const {
    textFieldValue,
    textFieldLabel,
    textFieldError,
    onTextFieldChange,
    textFieldHelperText,
    radioGroups,
    index,
    currentIndex,
    textFieldName,
    handleRadioButtonFieldChange,
    helperText,
    radioGroupValue,
    values,
    handleBlur,
    mode,
  } = props;

  // console.log("radioGroupValue",radioGroupValue)

  return (
    <>
      <p className={Styles.selectproof}>Select Nominee Proof (Optional)</p>
      <div className={Styles.NewDesignWrapper} style={{ alignItems: "center" }}>
        <div
          className={Styles.radioContainer}
          // style={{
          //   display: currentIndex === index ? "none" : "block",
          // }}
        >
          <div>
            <div className={Styles.labeltext}>Select document type</div>
            <RadioGroup
              {...props}
              onChange={handleRadioButtonFieldChange}
              sx={{
                // marginLeft: "25px",
                marginLeft: "0px",
                // border: "1px solid #E7EAEE",
                borderRadius: "8px",
                // width: "max-content",
                overflow: "hidden",
              }}
              className={Styles.radioSection}
            >
              {radioGroups.map((item: any, index: number) => (
                <FormControlLabel
                  key={index}
                  value={item}
                  sx={{
                    padding: "8px 14px",
                    // borderRight: "1px solid #E7EAEE",
                    // background: a.value === value?.value ? "#FAFAFA" : "",
                    // width: "98px !important",
                    "&:last-child": {
                      borderRight: "0px",
                    },
                  }}
                  className={Styles.radiowrap}
                  control={
                    <Radio
                      sx={{ width: "18px", height: "18px" }}
                      checkedIcon={
                        <img
                          src={TickCircle}

                          // style={{ width: "25px", height: "25px" }}
                        />
                      }
                      icon={
                        <img
                          src={EmptyCircle}
                          // style={{
                          //   filter:
                          //     mode === "dark"
                          //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                          //       : "",
                          // }}
                          // style={{ width: "25px", height: "25px" }}
                        />
                      }
                    />
                  }
                  label={
                    <p
                      className={Styles.radioLabel}
                      style={{
                        color: "var(--ds-text-primary)",
                        fontFamily: "inherit !important",
                      }}
                    >
                      {item}
                    </p>
                  }
                  checked={item === radioGroupValue}
                />
              ))}
            </RadioGroup>
            <FormHelperText style={{ color: "#d32f2f" }}>
              {helperText}
            </FormHelperText>
          </div>
        </div>{" "}
        {radioGroupValue && (
          <div className={Styles.newFeildWrapperIdproof}>
            <div className={Styles.labeltext}>Nominee ID Proof (Optional)</div>
            <TextField
              autoComplete="off"
              fullWidth
              {...props}
              className={Styles.proofTextFeild}
              // fullWidth
              // size="small"
              id="outlined-basic"
              placeholder={
                radioGroupValue === "Aadhaar Card"
                  ? "Enter Last 4 digits of Aadhaar"
                  : `Enter ${radioGroupValue} No`
              }
              variant="outlined"
              name={textFieldName}
              value={textFieldValue.toUpperCase()}
              error={textFieldError}
              helperText={textFieldHelperText}
              onChange={onTextFieldChange}
              onBlur={handleBlur}
              inputProps={{
                sx: {
                  "&::label": {
                    fill: "var(--ds-text-primary)",
                    fontWeight: 400,
                    fontSize: "14px",
                  },
                  color: "var(--ds-text-primary)",
                  fontSize: "14px",
                  fontFamily: "inherit",
                },
                maxLength: 50,
                inputMode: "text",
              }}
              sx={{
                fieldset: {
                  borderColor: "#E5E7EB",
                  // borderRadius: "100px",
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "var(--ds-text-primary)",
                  fontWeight: 400,
                  fontSize: "14px",
                  "&.MuiFormLabel-filled": {
                    color: "var(--ds-text-primary)",
                    fontWeight: 400,
                    fontSize: "15px",
                    fontFamily: "inherit",
                  },
                },
              }}
            />
          </div>
        )}
      </div>
    </>
  );
}

function TextFieldComponent(props: ITextProps) {}
